import React from 'react';
import {useTranslation} from 'react-i18next';
import ticketOpenImg from '../../../../assets/images/eTicket/ticketOpen.png';
import ticketScannedImg from '../../../../assets/images/eTicket/ticketScanned.png';
import ticketCanceledImg from '../../../../assets/images/eTicket/ticketCanceled.png';
import {getHourMinutes} from '../../../../library/dates';
import {StatusColor} from '../../StatusLabel/StatusLabel.css';
import * as css from './QrZoomTicketStatus.css';

interface QrZoomTicketStatusProps {
    scanned?: boolean;
    canceled?: boolean;
    scanTs?: number;
    isPop?: boolean;
}

function QrZoomTicketStatus({scanned = false, canceled = false, scanTs, isPop = false}: QrZoomTicketStatusProps): React.ReactElement {
    const {t} = useTranslation('eTicket');
    const color: StatusColor = canceled ? 'canceled' : scanned ? 'scanned' : 'brand';
    const statusText = t(canceled ? 'statusCanceled' : scanned ? 'statusScanned' : 'statusOpen');
    const image = canceled ? ticketCanceledImg : scanned ? ticketScannedImg : ticketOpenImg;
    const scanTime = !canceled && scanned && scanTs ? getHourMinutes(scanTs) : null;

    return (
        <>
            <css.status data-cy="qr-zoom-status">
                <css.caption>{t('ticketStatusCaption')}</css.caption>
                <css.pill $color={color} $isPop={isPop} aria-label={statusText} data-cy="qr-zoom-status-pill">
                    <css.label $color={color}>{statusText}</css.label>
                    <css.icon src={image} alt="" aria-hidden $canceled={canceled} />
                </css.pill>
            </css.status>
            {scanTime && (
                <css.scanInfo data-cy="qr-zoom-scan-info">
                    <css.scanRow>
                        <span>{t('scanTime')}</span>
                        <span dir="ltr">{scanTime}</span>
                    </css.scanRow>
                </css.scanInfo>
            )}
        </>
    );
}

export default QrZoomTicketStatus;
